import { render, staticRenderFns } from "./SimulacionLegend.vue?vue&type=template&id=684f0690&scoped=true&"
import script from "./SimulacionLegend.vue?vue&type=script&lang=js&"
export * from "./SimulacionLegend.vue?vue&type=script&lang=js&"
import style0 from "./SimulacionLegend.vue?vue&type=style&index=0&id=684f0690&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684f0690",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VSlideYReverseTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VCard,VCardText,VSlideYReverseTransition})
